<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "containerApp", // name use multi wolrd (containerApp) / (container-App)
};
</script>
